export default class Dropdown {
    constructor(ref) {
        this.ref = ref;
        const dataset = this.ref.dataset;
        this.options = JSON.parse(dataset.dropdownOptions);

        if (dataset.dropdownPlaceholder) {
            this.placeholder = dataset.dropdownPlaceholder;
        }
        if (dataset.defaultValue) {
            this.defaultValue = JSON.parse(dataset.defaultValue);
        }

        if (!dataset.dropdownReadonly) {
            this.readOnly = false;
        }
        // 		this.readOnly = dataset.dropdownReadonly ? false : '';
        if (!dataset.dropdownName) {
            this.name = "genericDropdown";
        } else {
            this.name = dataset.dropdownName;
        }

        // this.name = dataset.dropdownName ? 'genericDropdown' : '';
        this.multiple = dataset.dropdownMultiple;
        this.data = [];

        this.ref.innerHTML = this.render();
        this.visibleInput = this.ref.querySelector("[data-dropdown-input]");
        this.hiddenInput = this.ref.querySelector("[data-dropdown-value]");
        this.optionsList = this.ref.querySelector("[data-dropdown-list]");
        if (this.defaultValue) {
            const values = Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue];
            values.forEach(({ key, value }) => {
                this.setOption({ key, value: String(value) });
            })
        }



        this.addEventListeners();
        this.ref.dropdown = this;
    }
    render() {
        return /*html*/ `
            ${this.renderInputs()}
            <div class="form__dropdown_arrow" data-dropdown-arrow=""></div>
            <div class="form__dropdown_menu" data-dropdown-list data-simplebar>
                ${this.renderOptions()}
            </div>
			`;
    }
    renderInputs() {
        return /*html*/ `
            <input data-dropdown-input readonly name="${this.name}_visible" ${this.placeholder ? 'placeholder="' + this.placeholder + '"' : ""
            }>
            <!-- <input data-dropdown-value type="hidden" name="${this.name
            }" value="">-->
            <select data-dropdown-value name="${this.name}" ${this.multiple ? "multiple" : ""
            } style="display: none">
            ${this.options.reduce((html, option) => {
                const inData = this.data.find((selected) => selected.value === option.value);
                return (html += /*html*/ `<option ${inData ? 'selected' : ''} value="${option.value ?? ''}">${option.key} ${inData ? '+' : ''}</option>`);
            }, "")}
            </select>
			`;
    }
    renderOptions(options = this.options) {
        return options.reduce((html, option) => {
            switch (option.type) {
                case 'title':
                    return (html += /*html*/ `<p data-dropdown-title>${option.key}</p>`);
                case 'separator':
                    return (html += /*html*/ `<div data-dropdown-separator></div>`);
                default:
                    return (html += /*html*/ `<button type="button" data-dropdown-option data-dropdown-value="${option.value}" data-dropdown-display-value="${option.displayValue ?? option.key}">${option.key}</button>`);
            }

        }, "");
    }
    addEventListeners() {
        this.ref.addEventListener("click", this.handleClick.bind(this));
        this.optionsList.addEventListener(
            "mousedown",
            this.handleOptionClick.bind(this)
        );
        document.addEventListener('click', evt => {
            const dropdown = evt.target.closest('[data-dropdown]');
            if (!dropdown) this.handleInputBlur();

        })
    }
    handleInputFocus() {
        this.ref.classList.add("on-focus");

        if (!this.readOnly) {
            this.visibleInput.placeholder = "Поиск по названию";
            this.visibleInput.value = "";
        }

        document.dispatchEvent(
            new CustomEvent("dropdown::gotFocus", { detail: { el: this.ref } })
        );
    }
    handleInputBlur() {
        this.ref.classList.remove("on-focus");
        this.visibleInput.placeholder = this.placeholder;
        this.visibleInput.value = this.getVisibleValue();
        document.dispatchEvent(
            new CustomEvent("dropdown::lostFocus", { detail: { el: this.ref } })
        );
    }

    handleOptionClick({ target }) {
        const btn = target.closest("[data-dropdown-option]");

        this.setOption({
            key: String(btn.dataset.dropdownDisplayValue),
            value: String(btn.dataset.dropdownValue),
        });
    }

    handleClick(evt) {
        if (!this.ref.classList.contains("on-focus")) {
            this.ref.classList.add("on-focus");
        } else {
            if (!this.multiple || !evt.target.closest('[data-dropdown-list]')) {
                this.ref.classList.remove("on-focus");
            }
        }
    }

    setOption({ key, value }, generateEvt = true) {
        if (this.multiple) {
            const inData = this.data.find((option) => option.value === value);
            if (inData) {
                this.data = this.data.filter(
                    (option) => option.value !== value
                );
            } else {
                this.data = [...this.data, { key, value: String(value) }];
            }
        } else {
            this.data = [{ key, value: String(value) }];
        }

        this.visibleInput.value = this.getVisibleValue();
        this.visibleInput.classList.add("is-value");
        this.hiddenInput.value = value;
        document.dispatchEvent(
            new CustomEvent("dropdown::optionSet", {
                detail: {
                    el: this.ref,
                    data: this.data,
                },
            })
        );

        this.optionsList.querySelectorAll('[data-dropdown-value]').forEach(option => {
            option.classList.toggle('is-selected', this.data.map(({ value }) => value).includes(option.dataset.dropdownValue));
        })
        this.hiddenInput.querySelectorAll('option').forEach(option => {
            option.toggleAttribute('selected', this.data.map(({ value }) => value).includes(option.value));
        })

        document.dispatchEvent(
            new CustomEvent("dropdown::change", {
                detail: {
                    input: this.hiddenInput,
                },
            })
        );
        if (generateEvt) {
            const changeEvt = new Event("input", { bubbles: true });
            this.ref.dispatchEvent(changeEvt);
        }
    }
    handleInputInput({ target }) {
        const options = this.filterOptions(target.value);
        if (options.length) {
            this.optionsList.innerHTML = this.renderOptions(options);
        } else {
            this.optionsList.innerHTML =
                '<div data-dropdown-option class="is-disabled">Ничего не найдено</div>';
        }
    }
    filterOptions(query) {
        return this.options.filter(
            (option) => ~option.key.toLowerCase().indexOf(query.toLowerCase())
        );
    }

    reset(generateEvt, setEmpty = true) {
        this.data = [];
        setEmpty && this.setOption({ key: "", value: "" }, generateEvt);
    }

    getVisibleValue() {
        if (!this.data.length) {
            if (this.placeholder) return this.placeholder
        }
        return this.data.length === 1
            ? this.data[0].displayValue ?? this.data[0].key
            : `Выбрано: ${this.data.length}`;
    }

    setByIds(ids, generateEvt = false) {
        ids.forEach(id => {
            const option = this.options.find(option => String(option.value) === String(id));
            if (option) this.setOption(option, generateEvt)
        })
    }
}
